import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import logo from "./imgs/logopng.png";
import Home from "./components/pages/HomePage";
import PageMenu from "./components/PageMenu";
import SocialMedia from "./components/SocialMedia";
import ShowsPage from "./components/pages/ShowsPage";
import MusicPage from "./components/pages/MusicPage";
import GalleryPage from "./components/pages/GalleryPage";
import ContactPage from "./components/pages/ContactPage";
import LanguageSwitcher from "./components/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import "./i18n";
import TestComponent from "./components/minicomponents/TestComponent";
import ScrollToTopButton from "./components/minicomponents/ScrollToTop";

function App() {
  const { t } = useTranslation();
  const [isLogoOpen, setIsLogoOpen] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  const isMenuRoute = location.pathname === "/";
  const showPage = !isMenuRoute;

  useEffect(() => {
    let timeoutId;
    if (isLogoOpen && isMenuRoute) {
      timeoutId = setTimeout(() => {
        navigate("/home");
        // setIsMenuOpen(true);
        setIsLogoOpen(false);
      }, 2000);
    } else if (!isMenuRoute) {
      setIsLogoOpen(false);
    }

    return () => clearTimeout(timeoutId);
  }, [isLogoOpen, isMenuRoute, navigate]);
  useEffect(() => {
    if (location.hash) return; // Do not reset scroll if navigating to a hash anchor
    const scrollContainer = document.getElementById("main-content-scroll");
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
  }, [location.pathname, location.hash]);

  useEffect(() => {
    let key = "Home";
    if (location.pathname === "/music") key = "Music";
    else if (location.pathname === "/shows") key = "Shows";
    else if (location.pathname === "/gallery") key = "Gallery";
    else if (location.pathname === "/contact") key = "Contact";
    else if (location.pathname === "/about") key = "Home";

    const title = t(`seo.title${key}`, "LiveTheWill - Christelijke Band Huren & Begeleiding Diensten");
    const description = t(`seo.description${key}`, "Wil je een enthousiaste christelijke band huren voor je kerkdienst, bruiloft of evenement? LiveTheWill verzorgt de muzikale begeleiding van diensten.");

    document.title = title;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = description;
  }, [location.pathname, t]);

  const handleMenuLinkClick = () => {
    return;
  };

  const handleMenuBack = () => {
    setIsLogoOpen(false);
    // setIsMenuOpen(true);
    navigate("/home");
  };

  const handleBackgroundOrLogoClick = () => {
    if (isMenuRoute) {
      // setIsMenuOpen(true);
      setIsLogoOpen(false);
      navigate("/home");
    } else if (!isMenuRoute) {
      // handleMenuBack();
    }
  };

  return (
    <>
      <div
        className={`min-h-screen flex flex-col justify-center items-center transition-all duration-500 ease-in-out`}
        style={{
          backgroundColor: "black",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className={`fixed inset-0 flex flex-col justify-center items-center transition-all duration-1000 ease-in-out bg-black ${
            !isLogoOpen && showPage && location.pathname !== "/"
              ? "bg-opacity-0 z-0"
              : "z-50"
          }`}
          onClick={handleBackgroundOrLogoClick}
        ></div>

        {location.pathname === "/" && (
          <div className={!isMenuRoute ? "z-40" : "z-50"}>
            <div
              // We combine all positioning classes to keep the logo centered.
              // The ternary operator now only toggles opacity and interactivity.
              className={`fixed w-64 h-64 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-opacity duration-1000 ease-in-out ${
                isLogoOpen
                  ? "opacity-100 cursor-pointer"
                  : "opacity-0 pointer-events-none"
              }`}
              style={{
                // The zIndex can be kept here to ensure it's stacked correctly,
                // although the parent div also controls it.
                zIndex: 50,
              }}
              onClick={handleBackgroundOrLogoClick}
            >
              <img
                src={logo}
                alt="LiveTheWill Logo"
                className={`w-full h-full object-contain transition-all duration-1000 ease-in-out ${
                  !isMenuRoute ? "filter invert" : ""
                }`}
              />
            </div>
          </div>
        )}

        <div
          className={`fixed inset-0 transform transition-transform duration-500 ease-in-out z-0`}
        >
          <div
            id="main-content-scroll"
            className={`relative h-full overflow-auto`}
          >
            {showPage && (
              <PageMenu
                handleMenuBack={handleMenuBack}
                handleMenuItemClick={handleMenuLinkClick}
                t={t}
              />
            )}
            <div
              className={` bg-black-[200] ${
                location.pathname === "/test123123123123123123"
                  ? "px-0"
                  : "pb-0"
              }`}
            >
              <Routes>
                <Route path="/home" element={<Home t={t} />} />
                <Route path="/about" element={<Home t={t} />} />
                <Route path="/music" element={<MusicPage t={t} />} />
                <Route path="/shows" element={<ShowsPage t={t} />} />
                <Route path="/gallery" element={<GalleryPage t={t} />} />
                <Route path="/contact" element={<ContactPage t={t} />} />
                <Route
                  path="/test123123123123123123"
                  element={<TestComponent t={t} />}
                />
              </Routes>
            </div>
          </div>
        </div>
        <SocialMedia
          showPage={showPage}
          blackBackground={
            location.pathname === "/test123123123123123123" ||
            location.pathname === "/home" ||
            location.pathname === "/music" ||
            location.pathname === "/shows" ||
            location.pathname === "/gallery"
          }
        />
        <LanguageSwitcher />
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default App;
